import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select'

export default {
  name: 'ComboHub',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading
  },
  props: [],
  data() {
    return {
      comboHubBatch: '',
      bagintype: '',
      inscantype: '',
      batchDetails: '',
      inscanbagorbatch: '',
      outScanBagDetails: '',
      tableOfBatchDetails: false,
      BagOutShow: false,
      bagno: '',
      batchbagcount: 0,
      hubName: '',
      comboHubDetails: '',
      comboHubId: '',
      hubId: '',
      isLoading: false,
      isLoadingSearch: false,
      hubzoneid: '',
      HubID: '',
      showResulstHubSection: false,
      comboHubBatch: [],
      allBagsToInScan: [],
      pendingBags: [],
      inScanCount: 0,
      pendingBagCount: 0,
      outScanCount: 0,
      pendingBatchCount: 0,
      allBagsToInOutScan: [],
      pageCount: 0,
      pageCountForInScan: 0,
      pageCountForPendingBags: 0,
      pageNo: 0,
      pageNoForInScan: 0,
      pageCountForBatch: 0,
      pageNoForPendingBatch: 1,
      pageNoForPendingBags: 1,
      limit: 10,
      servicetype: 'Ecom',
      pageLimit: 10,
      pageLimitForInScan: 10,
      pageLimitForPendingBags: 10,
      pageLimitForPendingBatch: 10,
      totalRows: 0,
      totalRowsForInScan: 0,
      showParentBagIn: false,
      showRTOBagIn: false,
      flagLoadBatch: false,
      flagOutscan: false,
      flagInscan: false,
      showModal: false,
      showModalForAWB: false,
      showServiceType: '',
			hublist:[],
			hubitem:{value:'',text:''},
			hub:'',
			hubError:''
    }
  },
  computed: {

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail[0].email;
    this.hubId = userdetail[0].HubId[0];
    this.getComboHub();
    this.getHubName(userdetail[0].HubId);

  },
  methods: {
    onChange(event) {
      this.servicetype = event.target.value;
      this.listReset();
      if (this.showServiceType == 'ol') {
        this.getAllBagsToOutScan()
      }
      if (this.showServiceType == 'il') {
        this.getAllBagsToInScan()
      }
    },
    getOutscanBagCount() {
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getAllComboHubBatches?hubid=' + this.hubId,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.batchDetails = result.data.ResponseData
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          console.error(error)
        })
    },

    getBagOutScanList() {
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getAllBagsInComboHubBatchByBatchId?comboHubBatchId=' + this.batchDetails[0].combohubbatchid,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.outScanBagDetails = result.data.ResponseData
            this.batchbagcount = result.data.ResponseData.length
          } else {
            this.IsDisable = true
          }
        })
    },
    getHubName(hubid) {
      this.input = {
        hubids: hubid
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubName = result.data.ResponseData[0].HubName;
          } else {
            this.hubName = '';
          }
        }, error => {
          console.error(error)
        })
    },
    BagInscan() {
      if (this.inscanbagorbatch == '' || this.inscantype == '') {
        return false;
      }
      this.input = {
        currentHubId: this.hubId,
        currentHubName: this.hubName,
        lastModifiedBy: this.useremail,
        inScanFromDevice: "WEB",
      }
      if (this.inscantype == 'baginscan') {
        this.input.bagNo = this.inscanbagorbatch
      } else {
        this.input.batchId = this.inscanbagorbatch
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'comboHubInScan',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          },
          data: this.input
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.tableOfBatchDetails = false
            this.$alertify.success(result.data.ReturnMessage)
            this.resetForm();
          } else {
            this.IsDisable = true
            this.$alertify.error(result.data.ReturnMessage)
          }
          this.flagInscan = false
        })
    },

    bagOutScan() {
      if (this.bagno == '') {
        return false;
      }
      this.flagOutscan = true
      this.input = {
        HubId: this.hubId,
        CreatedBy: this.useremail,
        DestinationHubID: this.hubitem.value,
        BagNo: this.bagno,
        ComboHubBatchId: this.batchDetails[0].combohubbatchid,
        HubName: this.hubName
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'comboHubOutScan',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          },
          data: this.input
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.tableOfBatchDetails = true
            this.$alertify.success(result.data.ReturnMessage)
            this.getBagOutScanList()
            this.getOutscanBagCount();
            this.resetForm();
          } else {
            this.$alertify.error(result.data.ReturnMessage)
            this.resetForm();
          }
        })
    },

    closeBatch() {
      this.input = {
        ComboHubBatchId: this.batchDetails[0].combohubbatchid,
        ModifiedBy: this.useremail
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'closeComboHubBatch',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          },
          data: this.input
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage)
            this.tableOfBatchDetails = false
            this.outScanBagDetails = [];
            this.batchbagcount = 0
            this.BagOutShow = false;
            this.resetForm();
            // this.getBagOutScanList();
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
          this.flagLoadBatch = false
        })
    },

    loadOrCreateBatch() {
      this.flagLoadBatch = true
      this.input = {
        hubId: this.hubId,
        createdBy: this.useremail
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'createNewComboHubBatch',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          },
          data: this.input
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.tableOfBatchDetails = true
            this.BagOutShow = true
            this.$alertify.success(result.data.ReturnMessage)
            this.batchDetails = result.data.ResponseData
            this.getBagOutScanList()
            this.$validator.reset();
          } else {
            // this.IsDisable = true
            this.$alertify.error(result.data.ReturnMessage)
            this.$validator.reset();
          }
          this.flagLoadBatch = false
        })
    },

    bagTypeChange(event) {
      this.bagintype = event.target.value
      if (event.target.value === 'ParentBagIn') {
        this.showParentBagIn = true;
        this.showRTOBagIn = false
        this.tableOfBatchDetails = false
        this.BagOutShow = false
        this.batchbagcount = 0
      }
      if (event.target.value === 'RTOBagIn') {
        this.showRTOBagIn = true
        this.showParentBagIn = false
      }
    },

    getComboHub() {
      this.hublist = []
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getComboHub?hubId=' + this.hubId,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.showResulstHubSection = true
            this.comboHubDetails = result.data.ResponseData;
            //this.comboHubId = result.data.ResponseData.comboHubId;
            for (var i = 0; i < this.comboHubDetails.length; i++) {
              this.hublist.push({
                value: this.comboHubDetails[i].combosecondhubid,
                text: this.comboHubDetails[i].combosecondhub
              })
            }
          } else {
            this.IsDisable = true
            this.$alertify.error(result.data.ReturnMessage)
          }
        })
    },
    selectedHub(hubitem) {
      this.hubitem = hubitem
      this.hub = hubitem.text
      if (this.hub == '') {
        this.hubError = "Select Hub"
      } else {
        this.hubError = ""
				this.getAllBagsToInScan()
      }
    },
    getAllPendingBatch() {
      this.showServiceType = 'pb'
      this.input = {
        hubId: this.hubitem.value,
        limit: this.pageLimitForPendingBatch,
        offset: this.pageNoForPendingBatch,
        isAppRequest: false
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'getClosedComboHubBatch',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.showResulstHubSection = true
            this.comboHubBatch = result.data.ResponseData
            this.pendingBatchCount = result.data.TotalCount;
          } else {
            this.IsDisable = true
            this.$alertify.error(result.data.ReturnMessage);
          }
          let totalRowsForPendingBatch = result.data.TotalCount
          if (totalRowsForPendingBatch < this.pageLimitForPendingBatch) {
            this.pageCountForBatch = 1
          } else {
            this.pageCountForBatch = Math.ceil(totalRowsForPendingBatch / this.pageLimitForPendingBatch);
          }
        }, error => {
          console.error(error)
        })
    },
    getAllBagsToInScan() {
      this.allBagsToInScan = []
      this.showServiceType = 'il'
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getAllBagsToReceiveComboHubBatch?hubId=' + this.hubId + '&destinationHubId=' + this.hubitem.value + '&isAppRequest=' + false + '&ListType=' + this.servicetype + '&offset=' + this.pageNoForInScan + '&limit=' + this.pageLimitForInScan,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.showResulstHubSection = true
            this.allBagsToInScan = result.data.ResponseData;
            this.inScanCount = result.data.TotalCount;
          } else {
            this.IsDisable = true
            this.allBagsToInScan = []
            this.inScanCount = 0;
            this.$alertify.error(result.data.ReturnMessage)
          }
          let totalRowsForInScan = result.data.TotalCount;
          if (totalRowsForInScan < this.pageLimitForInScan) {
            this.pageCountForInScan = 1
          } else {
            this.pageCountForInScan = Math.ceil(totalRowsForInScan / this.pageLimitForInScan);
          }
        })
    },
    getAllBagsToOutScan() {
      this.showServiceType = 'ol'
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getAllBagsToHandoverComboHubBatch?hubId=' + this.hubId + '&isAppRequest=' + false + '&ListType=' + this.servicetype + '&PageIndex=' + this.pageNo + '&PageSize=' + this.pageLimit,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.showResulstHubSection = true
            this.allBagsToInOutScan = result.data.ResponseData;
            this.outScanCount = result.data.TotalCount;

          } else {
            this.IsDisable = true
            this.$alertify.error(result.data.ReturnMessage)
          }
          let totalRows = result.data.TotalCount
          if (totalRows < this.pageLimit) {
            this.pageCount = 1
          } else {
            this.pageCount = Math.ceil(totalRows / this.pageLimit);
          }
        })
    },
    getPaginationDataForOutScanBags(pageNum) {
      this.pageNo = (pageNum - 1);
      this.getAllBagsToOutScan();
    },
    getPaginationDataForPendingBatch(pageNum) {
      // this.pageNoForPendingBatch = (pageNum - 1);
      this.pageNoForPendingBatch = pageNum;
      this.getAllPendingBatch();
    },
    getPaginationDataForInScanBags(pageNum) {
      this.pageNoForInScan = (pageNum - 1);
      this.getAllBagsToInScan();
    },
    getPaginationDataForPendingBags(pageNum) {
      this.pageNoForPendingBags = pageNum;
      //this.pageNoForPendingBags = (pageNum - 1);
      this.ShowPendingBags(this.comboHubBatchId);
    },
    ShowPendingBags(data) {
      this.comboHubBatchId = data
      this.showModal = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getPendingBagsForComboHubBatch?HubId=' + this.hubId + '&ComboHubBatchId=' + this.comboHubBatchId + '&isAppRequest=' + false + '&PageIndex=' + this.pageNoForPendingBags + '&PageSize=' + this.pageLimitForPendingBags,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.pendingBags = result.data.ResponseData;
            this.pendingBagCount = result.data.TotalCount;

          } else {
            this.IsDisable = true
            this.$alertify.error(result.data.ReturnMessage)
          }
          let totalRows = result.data.TotalCount
          if (totalRows < this.pageLimitForPendingBags) {
            this.pageCountForPendingBags = 1
          } else {
            this.pageCountForPendingBags = Math.ceil(totalRows / this.pageLimitForPendingBags);
          }
        })
    },
    ShowPendingAWB(data) {
      this.showModalForAWB = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getAllComboHubBatchAWBNoList?comboHubBatchId=' + data,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.pendingBags = result.data.ResponseData;

          } else {
            this.IsDisable = true
            this.$alertify.error(result.data.ReturnMessage)
          }
        })
    },
    closeModal() {
      this.showModal = false;
      this.showModalForAWB = false;
      this.pendingBags = [];
      this.pendingBagCount = 0
    },
    resetFlt() {
      this.ComboHubDetails = []
      this.isLoadingSearch = false
    },
    onSubmit: function() {
      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            console.log('errors exist', this.errors);
            return false;
          } else {
            //this.saveComboHubConfiguration();
          }
        }).catch(() => {
          console.log('errors exist', this.errors);
        });
    },
    listReset() {
      this.allBagsToInOutScan = '';
      this.allBagsToInScan = '';
      this.outScanCount = '';
      this.inScanCount = 0;
      this.pageNo = 0;
      this.pageNoForInScan = 0;
    },
    resetForm() {
      this.inscanbagorbatch = '';
      this.bagno = '';
      this.flagOutscan = false;
      this.flagInscan = false;
      //this.listconeectionDetails = '';
      this.routetype = '';
      this.connectiontype = '';
      this.connectionname = '';
      this.resultHubID = '';
      this.ConnectionID = '';
      this.DesHubID = ''
      this.$validator.reset();
    },
    resetForm1() {
      this.flagOutscan = false
      this.flagInscan = false
      this.BagOutShow = false
      this.inscanbagorbatch = '';
      this.inscantype = '';
      this.bagno = '';
      this.batchbagcount = 0;
      //this.listconeectionDetails = '';
      this.routetype = '';
      this.connectiontype = '';
      this.connectionname = '';
      this.resultHubID = '';
      this.ConnectionID = '';
      this.DesHubID = ''
      this.$validator.reset();
    },

    closeStatusModal() {
      this.addmodalShow = false
    },
    takeAction() {
      this[this.fncAction]()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/combohub/combohub.js